<template>
  <list-view
    :with-sites="false"
    color="primary"
    :site="$attrs.site_key"
    :label="$attrs.site_title"
    :items="members"
    :create-item="'members_create'"
    :items-name="'members'"
    :edit-item="'members_edit'"
    :avatar-url="'image.sizes.50'"
    :description-field="'post'"
    :title-field="'name'"
    @remove-item="updateData"
  ></list-view>
</template>

<script>
import api from '@/mixins/api'
import ListView from '@/components/ListView'
import list_view from '@/mixins/list_view'

export default {
  name: 'main',
  components: { ListView },
  mixins: [api, list_view],
  data() {
    return {
      members: [],
    }
  },
  watch: {
    '$attrs.site_key'() {
      this.updateData()
    },
  },
  mounted() {
    this.updateData()
  },
  methods: {
    updateData() {
      this.axios({
        url: '/v1/members',
        method: 'get',
        params: { site_key: this.$attrs.site_key },
      })
        .then((resp) => {
          this.members = resp.data || []
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>

<style scoped lang="scss">
.member {
  cursor: pointer;
  margin: 10px;
}

.member__info {
  margin: 10px;
}
</style>
